import PropTypes from 'prop-types';
import { Tabs, Tab } from '@mui/material';
import styles from './SideNav.module.scss';

const SideNav = ({ heading, tabs, setValue, value }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.tabs}>
        <div className={styles.heading}>{heading}</div>
        <Tabs orientation="vertical" value={value} onChange={(_event, newValue) => setValue(newValue)}>
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              iconPosition="start"
              icon={tab.icon}
              label={tab.label}
              sx={{
                justifyContent: 'start',
                textAlign: 'left',
                cursor: 'pointer',
                textTransform: 'capitalize',
                color: '#1976d2',
                minHeight: 48,
              }}
            />
          ))}
        </Tabs>
      </div>
    </div>
  );
};

SideNav.propTypes = {
  heading: PropTypes.string,
  tabs: PropTypes.array,
  setValue: PropTypes.func,
  value: PropTypes.number,
};

export default SideNav;
